import buildTemplateContext from './build-template-context';
import normalizeVariableDefinitions from './normalize-variable-definitions';
import resolveVariable from './resolve-variable';
import resolveSchemeVariable from './resolve-scheme-variable';
import buildColorSchemesRegistry, {
  buildRegistrySchemeEntry,
} from './build-color-schemes-registry';
import buildOutput, { resolveSchemeVariables } from './build-output';
import { parseColorInput, parseColorMap, normalizeSchemes } from './parse-colors';
import { serializeColors, serializePaletteSchemes } from './serialize-colors';
import extractRawState from './extract-raw-state';

export default {
  buildTemplateContext,
  normalizeVariableDefinitions,
  resolveVariable,
  resolveSchemeVariable,
  buildColorSchemesRegistry,
  buildRegistrySchemeEntry,
  buildOutput,
  resolveSchemeVariables,
  parseColorInput,
  parseColorMap,
  normalizeSchemes,
  serializeColors,
  serializePaletteSchemes,
  extractRawState,
};
